import React from 'react';
import WalletPopper from '../WalletPopper/WalletPopper';
import WalletLoader from '../WalletLoader/WalletLoader';
import { useAccount } from 'wagmi';

type Props = {
  isOnBottom?: boolean;
};

const WalletContainer: React.FC<Props> = (props) => {
  const { isConnecting, isReconnecting } = useAccount();
  const fetching = isConnecting || isReconnecting;

  const renderWalletWidget = () => {
    if (fetching) {
      return (
        <div className="flex flex-row justify-center items-center ml-3 w-32">
          <WalletLoader size={40} color="lightBlue" />
        </div>
      );
    }
    return <WalletPopper isOnBottom={props.isOnBottom} />;
  };

  return <>{renderWalletWidget()}</>;
};

export default WalletContainer;
